import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { WorkCompletionFormDTO } from '../../models/work-completion-form-dto.model';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { Languages, Service, AttachmentType } from 'src/app/shared/models/enums.model';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { LookupService } from 'src/app/front-user/shared/services/lookup.service';
import { LookUp } from 'src/app/front-user/shared/models/look-up.model';
import { WorkCompletionFormService } from '../../services/work-completion-form.service';
import { Attachment } from 'src/app/front-user/shared/models/attachment.model';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { fileService } from 'src/app/front-user/shared/services/file.service';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { AdditionalWorkService } from '../../services/additional-work.service';
import { AppConfig } from 'src/app/shared/services/app.config';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';

@Component({
  selector: 'app-work-completion-form',
  templateUrl: './work-completion-form.component.html',
  styleUrls: ['./work-completion-form.component.css']
})

export class WorkCompletionFormComponent implements OnInit {

  workCompletionForm: FormGroup;
  workCompletionFormDTO: WorkCompletionFormDTO;
  FloatingCranesesNames: LookUp[];
  FloatingCranesTypes: LookUp[];
  responseObj: ResponseObject;
  submitted = false;
  loading = false;
  RequestId: string;
  CurrServiceTypeId: number;
  displayedLang: any;
  Languages = Languages;
  BillPlanProgress: number;
  CertificatePlanProgress: number;
  serviceType = Service;
  completionFormAttachments: Attachment[] = [];
  public readonly QualityControlGate: Array<number> = [10, 11, 12];
  public readonly FloatingCranesGate: number = 7;
  numberRegex: string = '^[0-9]*$';
  showRequest = true;
  isAdditional: boolean = false;
  isReadOnly: boolean = false;
  attachments: Attachment[] = [];
  isErrorMessage: boolean = false;
  requestMode: string;
  viewMode: boolean = false;
  BillAttachmentUrl;
  CertificateAttachmentUrl;
  billAttachmentExist : string;
  lockTaskErrorMessage : boolean = false;

  constructor(private lookupService: LookupService, private fileService: fileService, private formBuilder: FormBuilder, private route: ActivatedRoute, private global: GlobalServices, private workCompletionService: WorkCompletionFormService, private file: fileService, private translate: TranslateService, private additinalWorkService: AdditionalWorkService, private alertService: AlertService, private authSrevice: AuthenticationService

  ) {
    if (history.state.data && history.state.data.requestId){
      this.RequestId = history.state.data.requestId;
    } else {
      window.history.back();
    }
    this.displayedLang = this.global.getLanguage();
    this.createForm();
    this.getCompletionFormLookUps();
    this.getReadOnlyProperties();
  }

  ngOnInit() {
    this.isReadOnly = true;
    this.requestMode = this.route.snapshot.routeConfig.path;
    if (this.requestMode == "addCompletionForm") {
      this.viewMode = false;
    }
    else {
      this.viewMode = true;
      this.getWorkCompeletion();
    }
    this.getAdditionalWork(this.RequestId);
    if (history.state.data && history.state.data.isCompleted) {
      this.viewMode = true;
      this.getWorkCompeletion();
    }
  }

  getWorkCompeletion() {
    this.workCompletionService.getWorkCompletionForm(this.RequestId).subscribe(
      d => {
        this.workCompletionFormDTO = d.Data;
        this.workCompletionForm.patchValue({
          EndDate: new Date(this.workCompletionFormDTO.EndDate),
          TotalCost: this.workCompletionFormDTO.TotalCost,
          WorkDescription: this.workCompletionFormDTO.WorkDescription,
          QualityControl: {
            TestTypeControl: this.workCompletionFormDTO.TestType,
            TestDateControl: new Date(this.workCompletionFormDTO.TestDate)
          },
          FloatingCranesControl: {
            FloatingCranesControl: this.workCompletionFormDTO.FloatingCranesId,
            FloatingCranesTypeControl: this.workCompletionFormDTO.FloatingCranesTypeId
          }


        });
        //attachment
        var baseUrl = AppConfig.settings.apiServer.UploadsUrl;
        var shipyardUploadsFolder = AppConfig.settings.apiServer.ShipyardUploadsFolder;

        this.BillAttachmentUrl = this.workCompletionFormDTO.Attachments.find(x => x.AttachmentType == AttachmentType.WorkCompletionBill) != undefined ?
          this.workCompletionFormDTO.Attachments.find(x => x.AttachmentType == AttachmentType.WorkCompletionBill).URL : '';
        this.CertificateAttachmentUrl = this.workCompletionFormDTO.Attachments.find(x => x.AttachmentType == AttachmentType.WorkCompletionCertificate) != undefined ?
          this.workCompletionFormDTO.Attachments.find(x => x.AttachmentType == AttachmentType.WorkCompletionCertificate).URL : '';
        this.BillAttachmentUrl = baseUrl + shipyardUploadsFolder + "/" + this.BillAttachmentUrl;
        this.CertificateAttachmentUrl = baseUrl + shipyardUploadsFolder + "/" + this.CertificateAttachmentUrl;
        this.billAttachmentExist = this.BillAttachmentUrl.substring(this.BillAttachmentUrl.lastIndexOf('/')+1);
      }
    );
  }

  get Validate() {
    return this.workCompletionForm.controls;
  }

  get ValidateQualityControl() {
    return this.workCompletionForm.controls.QualityControl['controls'];
  }

  get ValidateFloatingCranesControl() {
    return this.workCompletionForm.controls.FloatingCranesControl['controls'];
  }

  get AttachmentType() {
    return AttachmentType;
  }

  get ValidateDateComparsion() {
    let Gate = false;
    let currStartDate = new Date(this.workCompletionForm.controls.StartDate.value);
    let currEndDate = new Date(this.workCompletionForm.controls.EndDate.value);
    if (currStartDate.getFullYear() > currEndDate.getFullYear()) {
      Gate = true;
    }
    else if (currStartDate.getFullYear() == currEndDate.getFullYear()) {
      if (currStartDate.getMonth() > currEndDate.getMonth()) {
        Gate = true;
      }
      else if (currStartDate.getMonth() == currEndDate.getMonth()) {
        if (currStartDate.getDate() > currEndDate.getDate()) {
          Gate = true;
        }
      }
    }
    return Gate;
  }

  getCompletionFormLookUps() {
    //Get JobTypes Lookup
    this.lookupService.GetFloatingCranesNames().subscribe(
      fn => {
        this.FloatingCranesesNames = fn.Data;
      }
    );

    //Get ClassificationSocieties Lookup
    this.lookupService.GetFloatingCranesTypes().subscribe(
      ft => {
        this.FloatingCranesTypes = ft.Data;
      }
    );
  }

  createForm() {
    this.workCompletionForm = this.formBuilder.group({
      Id: [this.RequestId],
      Department: [''],
      RequestDate: [''],
      StartDate: [new Date(), Validators.required],
      EndDate: ['', Validators.required],
      WorkDescription: ['', Validators.required],
      QualityControl: this.formBuilder.group({
        TestTypeControl: [''],
        TestDateControl: [null],
        CertificateControl: ['']
      }),
      FloatingCranesControl: this.formBuilder.group({
        FloatingCranesControl: [null],
        FloatingCranesTypeControl: [null],
      }),
      TotalCost: ['', [Validators.required, /*Validators.pattern(this.numberRegex)*/]],
      Bill: [''],
      TestType: [''],
      TestDate: [null],
      Certificate: [''],
      FloatingCranesId: [null],
      FloatingCranesTypeId: [null],
    });
  }

  getAdditionalWork(baseRequestId) {
    this.additinalWorkService.getAdditionalWork(this.RequestId).subscribe(
      d => {
        if (d.Data != null) {
          this.isAdditional = true;

        }

      }
    )
  }



  getReadOnlyProperties() {
    if (this.RequestId) {
      this.workCompletionService.getReadOnlyProperties(this.RequestId).subscribe(
        ro => {
          this.CurrServiceTypeId = ro.Data.ServiceId;
          this.workCompletionForm.controls['Department'].setValue(this.displayedLang == Languages.English ? ro.Data.ServiceNameEN : ro.Data.ServiceNameAR);
          this.workCompletionForm.controls['RequestDate'].setValue(new Date(ro.Data.RequestDate));
          if (this.QualityControlGate.includes(this.CurrServiceTypeId)) {
            this.ValidateQualityControl.TestTypeControl.setValidators([Validators.required, Validators.maxLength(50)]);
            this.ValidateQualityControl.TestDateControl.setValidators([Validators.required]);
            this.ValidateQualityControl.CertificateControl.setValidators([Validators.required]);
          }
          else if (this.CurrServiceTypeId == this.FloatingCranesGate) {
            this.ValidateFloatingCranesControl.FloatingCranesControl.setValue('');
            this.ValidateFloatingCranesControl.FloatingCranesTypeControl.setValue('');
            this.ValidateFloatingCranesControl.FloatingCranesControl.setValidators([Validators.required]);
            this.ValidateFloatingCranesControl.FloatingCranesTypeControl.setValidators([Validators.required]);
          }
        }
      );
    }
  }

  async AddAttachmentFile(event, currFormControl, docName, attachmentType: AttachmentType, progressVariableName, key) {
    this[progressVariableName] = 0;
    this.alertService.clear();
    let localizationKeyValue = await this.translate.get(key).toPromise();
    if (!this.fileService.IsFileExtentionValid(event)) {
      currFormControl.setValue('');
      var errorMessage = await this.translate.get('FRONT_USER.NotAllowedFileExtentionMessage').toPromise();
      this.alertService.error(localizationKeyValue + ' ' + errorMessage);
      let invalidElements = document.getElementsByClassName('alert-danger');
      event.target.value = "";
      window.scrollTo(0, 0);
      // if (invalidElements && invalidElements.length>0) {
      //   invalidElements[0].scrollIntoView();
      // }
      return false;

    }

    else if (!this.fileService.IsFileSizeValid(event)) {
      currFormControl.setValue('');
      var errorMessage = await this.translate.get('FRONT_USER.NotAllowedFileSize').toPromise();
      this.alertService.error(localizationKeyValue + ' ' + errorMessage);
      let invalidElement = document.getElementsByClassName('alert-danger');
      event.target.value = "";
      window.scrollTo(0, 0);
      // if (invalidElement && invalidElement.length>0) {
      //   invalidElement[0].scrollIntoView();
      // }
      return false;

    }

    const file = event.target.files[0];
    const formData = new FormData();
    formData.append('File', file);
    formData.append('DocumentName', docName);
    formData.append('FolderName', AppConfig.settings.apiServer.ShipyardUploadsFolder);
    this.fileService.fileUploader(formData).subscribe(
      event => {

        if (event.type === HttpEventType.UploadProgress) {

          // This is an upload progress event. Compute and show the % done:
          const percentDone = Math.round(100 * event.loaded / event.total);

          // console.log(`File is ${percentDone}% uploaded.`);


          this[progressVariableName] = percentDone;
          currFormControl.setErrors({ 'invalid': true });

        } else if (event instanceof HttpResponse) {
          currFormControl.setErrors(null);
          const jsonResponse = event.body.Data;
          const Url = jsonResponse.Url;
          const attachment = new Attachment();
          attachment.URL = Url;
          attachment.DocumentName = docName;
          attachment.AttachmentTypeId = attachmentType;
          attachment.BaseRequestId = this.RequestId;

          this.completionFormAttachments = this.completionFormAttachments.filter(h => h.DocumentName != docName);
          this.completionFormAttachments.push(attachment);
        }
      }
    );

  }

  mapNestedControls() {
    let TestTypeControl = this.workCompletionForm.controls['QualityControl'].value.TestTypeControl;
    let TestDateControl = this.workCompletionForm.controls['QualityControl'].value.TestDateControl;
    let CertificateControl = this.workCompletionForm.controls['QualityControl'].value.CertificateControl;
    let FloatingCranesControl = this.workCompletionForm.controls['FloatingCranesControl'].value.FloatingCranesControl;
    let FloatingCranesTypeControl = this.workCompletionForm.controls['FloatingCranesControl'].value.FloatingCranesTypeControl;
    this.workCompletionForm.controls['TestType'].setValue(TestTypeControl);
    this.workCompletionForm.controls['TestDate'].setValue(TestDateControl);
    this.workCompletionForm.controls['Certificate'].setValue(CertificateControl);
    this.workCompletionForm.controls['FloatingCranesId'].setValue(FloatingCranesControl);
    this.workCompletionForm.controls['FloatingCranesTypeId'].setValue(FloatingCranesTypeControl);
  }

  onSubmit() {
    this.submitted = true;
    if (this.workCompletionForm.invalid || this.ValidateDateComparsion) {
      return;
    }
    //Enable Loader
    this.global.isLoaderEnabled = true;
    this.mapNestedControls();
    this.loading = true;
    this.workCompletionFormDTO = this.workCompletionForm.value;
    this.workCompletionFormDTO.serviceId = this.CurrServiceTypeId;
    this.workCompletionFormDTO.userName = this.authSrevice.currentUserValue.UserName;
    this.workCompletionFormDTO.Attachments = this.completionFormAttachments;
    this.workCompletionFormDTO.Bill = "";
    this.workCompletionFormDTO.Certificate = "";
    this.workCompletionService.AddWorkCompletionForm(this.workCompletionFormDTO).subscribe(
      (data: ResponseObject) => {
        this.responseObj = data;
        if (this.responseObj.Success) {
          this.workCompletionForm.reset();
          this.showRequest = false;
          this.loading = false;
          this.showRequest = false;
          //Disable Loader
          this.global.isLoaderEnabled = false;
        }else if( this.responseObj.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser")!=null) {
          this.lockTaskErrorMessage = true;
          this.showRequest = false;
          //Disable Loader
          this.global.isLoaderEnabled = false;
        }
        else {
          this.loading = false;
          this.isErrorMessage = true;
          this.showRequest = false;
          //Disable Loader
          this.global.isLoaderEnabled = false;
        }
      });
  }
}
